"use strict";
/**
 * This file is auto-generated. Do not modify directly.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Formatters = exports.Messages = exports.CurrentMessageLocale = exports.LocaleData = exports.getCurrentMessageLocale = exports.getLocalizeFormat = void 0;
/* istanbul ignore next */
function getLocalize() {
    var globalContainer;
    if (typeof process !== 'undefined' && typeof process.release !== 'undefined' && process.release.name === 'node') {
        globalContainer = global;
    }
    else {
        //@ts-ignore
        globalContainer = window;
    }
    var localizeNamespace = globalContainer;
    if (typeof CustomLocalizeNamespace === 'string') {
        localizeNamespace = globalContainer[CustomLocalizeNamespace];
    }
    if (typeof localizeNamespace.Localize === 'undefined') {
        throw Error('The messages.<locale>.js file has not been loaded');
    }
    return localizeNamespace.Localize;
}
;
/* istanbul ignore next */
var getLocalizeFormat = function () {
    var localize = getLocalize();
    if (localize.format === undefined) {
        throw Error('The formatters-and-parsers.<locale>.js file has not been loaded');
    }
    return localize.format;
};
exports.getLocalizeFormat = getLocalizeFormat;
/* istanbul ignore next */
var getCurrentMessageLocale = function () {
    var localize = getLocalize();
    if (localize.message.currentLocale === undefined) {
        throw Error('The localize.message.currentLocale has not been set');
    }
    return localize.message.currentLocale;
};
exports.getCurrentMessageLocale = getCurrentMessageLocale;
/* istanbul ignore next */
exports.LocaleData = { get: function () { return (0, exports.getLocalizeFormat)().localeData; } };
/* istanbul ignore next */
exports.CurrentMessageLocale = { get: function () { return (0, exports.getCurrentMessageLocale)(); } };
var t = function (k, a) { return getLocalize().msg.formatMessage(k, a); };
exports.Messages = {
    notUpdated: function () { return t('@tableau__metrics-shared-widgets-dom/notUpdated'); },
    syncedDate: function (a) { return t('@tableau__metrics-shared-widgets-dom/syncedDate', a); },
    selectedDate: function (a) { return t('@tableau__metrics-shared-widgets-dom/selectedDate', a); },
    noData: function () { return t('@tableau__metrics-shared-widgets-dom/noData'); },
    refreshedSince: function (a) { return t('@tableau__metrics-shared-widgets-dom/refreshedSince', a); },
    refreshSuspended: function () { return t('@tableau__metrics-shared-widgets-dom/refreshSuspended'); },
    weekOf: function (a) { return t('@tableau__metrics-shared-widgets-dom/weekOf', a); },
    timelineUnavailable: function () { return t('@tableau__metrics-shared-widgets-dom/timelineUnavailable'); },
    ariaTimeseriesDescription: function () { return t('@tableau__metrics-shared-widgets-dom/ariaTimeseriesDescription'); },
    ariaTimeseriesInteractiveDescription: function () { return t('@tableau__metrics-shared-widgets-dom/ariaTimeseriesInteractiveDescription'); },
    ariaLabelMetricName: function () { return t('@tableau__metrics-shared-widgets-dom/ariaLabelMetricName'); },
    ariaLabelSelectedValue: function () { return t('@tableau__metrics-shared-widgets-dom/ariaLabelSelectedValue'); },
    ariaLabelSelectedTime: function () { return t('@tableau__metrics-shared-widgets-dom/ariaLabelSelectedTime'); },
    ariaLabelLastRefresh: function () { return t('@tableau__metrics-shared-widgets-dom/ariaLabelLastRefresh'); },
    ariaWindowSwitcher: function () { return t('@tableau__metrics-shared-widgets-dom/ariaWindowSwitcher'); },
    AboveValue: function () { return t('@tableau__metrics-shared-widgets-dom/AboveValue'); },
    AtValue: function () { return t('@tableau__metrics-shared-widgets-dom/AtValue'); },
    BelowValue: function () { return t('@tableau__metrics-shared-widgets-dom/BelowValue'); },
    GoodStatus: function () { return t('@tableau__metrics-shared-widgets-dom/GoodStatus'); },
    NeutralStatus: function () { return t('@tableau__metrics-shared-widgets-dom/NeutralStatus'); },
    BadStatus: function () { return t('@tableau__metrics-shared-widgets-dom/BadStatus'); },
    Status: function () { return t('@tableau__metrics-shared-widgets-dom/Status'); },
    HistoricalComparison: function () { return t('@tableau__metrics-shared-widgets-dom/HistoricalComparison'); },
    ConstantComparison: function () { return t('@tableau__metrics-shared-widgets-dom/ConstantComparison'); },
    NoComparison: function () { return t('@tableau__metrics-shared-widgets-dom/NoComparison'); },
    ConstantComparisonValue: function () { return t('@tableau__metrics-shared-widgets-dom/ConstantComparisonValue'); },
    ComparisonTypeLabel: function () { return t('@tableau__metrics-shared-widgets-dom/ComparisonTypeLabel'); },
    ConstantComparisonInputErrorMessage: function () { return t('@tableau__metrics-shared-widgets-dom/ConstantComparisonInputErrorMessage'); },
    DateRange: function () { return t('@tableau__metrics-shared-widgets-dom/DateRange'); },
    CustomOption: function () { return t('@tableau__metrics-shared-widgets-dom/CustomOption'); },
    CustomRange: function () { return t('@tableau__metrics-shared-widgets-dom/CustomRange'); },
    CustomStartDate: function () { return t('@tableau__metrics-shared-widgets-dom/CustomStartDate'); },
    CustomStartDateError: function (a) { return t('@tableau__metrics-shared-widgets-dom/CustomStartDateError', a); },
    CustomStartDateRangeError: function (a) { return t('@tableau__metrics-shared-widgets-dom/CustomStartDateRangeError', a); },
    RelativeDate: function (a) { return t('@tableau__metrics-shared-widgets-dom/RelativeDate', a); },
    HistoricalComparisonInputErrorMessage: function () { return t('@tableau__metrics-shared-widgets-dom/HistoricalComparisonInputErrorMessage'); },
    ShowComparisonLineToggleLabel: function () { return t('@tableau__metrics-shared-widgets-dom/ShowComparisonLineToggleLabel'); },
    RelativeDateWindowInputErrorMessage: function () { return t('@tableau__metrics-shared-widgets-dom/RelativeDateWindowInputErrorMessage'); },
    Seconds: function () { return t('@tableau__metrics-shared-widgets-dom/Seconds'); },
    Minutes: function () { return t('@tableau__metrics-shared-widgets-dom/Minutes'); },
    Hours: function () { return t('@tableau__metrics-shared-widgets-dom/Hours'); },
    Days: function () { return t('@tableau__metrics-shared-widgets-dom/Days'); },
    Weeks: function () { return t('@tableau__metrics-shared-widgets-dom/Weeks'); },
    Months: function () { return t('@tableau__metrics-shared-widgets-dom/Months'); },
    Quarters: function () { return t('@tableau__metrics-shared-widgets-dom/Quarters'); },
    Years: function () { return t('@tableau__metrics-shared-widgets-dom/Years'); },
    Marks: function () { return t('@tableau__metrics-shared-widgets-dom/Marks'); },
    SecondsAgo: function () { return t('@tableau__metrics-shared-widgets-dom/SecondsAgo'); },
    MinutesAgo: function () { return t('@tableau__metrics-shared-widgets-dom/MinutesAgo'); },
    HoursAgo: function () { return t('@tableau__metrics-shared-widgets-dom/HoursAgo'); },
    DaysAgo: function () { return t('@tableau__metrics-shared-widgets-dom/DaysAgo'); },
    WeeksAgo: function () { return t('@tableau__metrics-shared-widgets-dom/WeeksAgo'); },
    MonthsAgo: function () { return t('@tableau__metrics-shared-widgets-dom/MonthsAgo'); },
    QuartersAgo: function () { return t('@tableau__metrics-shared-widgets-dom/QuartersAgo'); },
    YearsAgo: function () { return t('@tableau__metrics-shared-widgets-dom/YearsAgo'); },
    MarksAgo: function () { return t('@tableau__metrics-shared-widgets-dom/MarksAgo'); },
    Snapshot: function () { return t('@tableau__metrics-shared-widgets-dom/Snapshot'); },
};
exports.Formatters = {
    formatLongBestFitRelativeTime: function (to, from) { return (0, exports.getLocalizeFormat)().formatBestFitRelativeTime(to, { "form": "long" }, from); },
};
//# sourceMappingURL=Localize.js.map